<!-- --svz-search-hint carries the prototype's literal #717182: no semantic token maps to it safely
     here — text-muted-foreground (#737373) needs the Zard/shadcn token bridge, which not all
     of this shared component's consumer apps have installed, so it would silently break in the
     ones that don't (the same bug this literal was introduced to fix). Declared once so the
     button icon and the placeholder don't each carry their own copy of the hex. -->
<div class="flex w-full items-center border border-[#e4e7ea] bg-card px-1 transition-colors focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/35 [--svz-search-hint:#717182]" [ngClass]="radiusClass()" [class.h-10]="size() === 'md'" [class.h-11]="size() === 'lg'">
  <button
    type="button"
    [svcTestId]="magnifierTestId()"
    (click)="magnifierTriggersSearch() && forceEmit()"
    [disabled]="disabled()"
    class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded text-[var(--svz-search-hint)] transition hover:bg-hover disabled:opacity-50 disabled:cursor-not-allowed"
    [ngClass]="magnifierStaticColor() ? '' : 'hover:text-default'"
    [attr.aria-label]="'Pesquisar' | transloco"
  >
    <ng-icon name="svcSearch" class="icon-size-[18px]"></ng-icon>
  </button>

  <input
    [id]="inputId()"
    [svcTestId]="inputTestId()"
    [formControl]="formControl"
    type="search"
    class="h-full w-full bg-transparent pl-1 pr-3 text-sm text-[#2a2a2a] outline-none placeholder:text-[var(--svz-search-hint)]"
    [placeholder]="'Pesquisar' | transloco"
    (keydown.enter)="forceEmit()"
  />
</div>
